/* @flow */
import * as React from 'react';

const PayOnline = props => (
  <svg
    width={80}
    height={93}
    viewBox="0 0 80 93"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <path
      fill="#DEDEDE"
      d="M60.811,83.114 C60.837,83.35 60.877,83.583 60.926,83.816 C59.656,85.172 57.856,86.026 55.856,86.026 L30.37,86.026 C30.57,85.173 30.57,84.259 30.316,83.335 C30.278,83.197 30.23,83.062 30.18,82.928 L55.856,82.928 C57.917,82.928 59.592,81.297 59.692,79.26 C59.74,79.277 59.79,79.291 59.839,79.306 C59.884,79.377 59.927,79.453 59.972,79.512 C59.998,79.588 60.028,79.662 60.053,79.739 C60.271,80.487 60.486,81.225 60.638,81.99 C60.655,82.076 60.7,82.4 60.744,82.686 C60.758,82.841 60.783,83.029 60.811,83.114 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M58.181,36.576 L74.674,27.267 C76.688,26.058 78.04,23.86 78.04,21.341 C78.04,17.522 74.944,14.426 71.126,14.426 C69.234,14.426 66.273,16.418 66.273,16.418 L58.032,21.297 C55.854,22.504 53.414,25.075 53.414,28.211"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M13.242,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,17.019"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      fill="none"
      d="M13.242,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,17.019"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#1B1E33"
      d="M61.259,66.226 L61.259,6.904 C61.259,3.92 58.84,1.5 55.855,1.5 L18.646,1.5 C15.662,1.5 13.243,3.92 13.243,6.904 L13.243,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,66.226 Z"
    />
    <polygon fill="#FFFFFF" points="13.243 71.61 61.259 71.61 61.259 10.401 13.243 10.401" />
    <path
      fill="#000000"
      d="M52.836,37.831 C51.581,37.708 50.333,37.696 49.097,37.795 L49.097,33.417 C49.097,32.661 48.523,32.026 47.769,31.951 C42.744,31.46 37.845,32.751 33.272,35.755 C32.257,36.335 31.249,37.003 30.273,37.648 C26.294,40.283 22.658,41.783 20.051,40.367 C19.594,40.12 19.042,40.13 18.596,40.396 C18.15,40.662 17.876,41.142 17.876,41.661 L17.876,57.448 C17.876,58.205 18.451,58.839 19.204,58.914 C19.902,58.982 20.597,59.016 21.289,59.016 C21.842,59.016 23.427,58.992 23.977,58.949 L23.977,64.36 C23.977,65.118 24.551,65.751 25.304,65.826 C26.002,65.894 26.697,65.929 27.389,65.929 C31.681,65.929 35.864,64.609 39.802,62.022 C40.814,61.442 41.823,60.776 42.797,60.13 C46.78,57.494 49.387,55.993 51.989,57.411 C52.445,57.657 52.999,57.648 53.444,57.382 C53.89,57.117 54.164,56.637 54.164,56.117 L54.164,39.297 C54.164,38.539 53.589,37.906 52.836,37.831"
      style={{ mixBlendMode: 'soft-light' }}
      opacity={0.3}
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M61.259,66.226 L61.259,6.904 C61.259,3.92 58.84,1.5 55.855,1.5 L18.646,1.5 C15.662,1.5 13.243,3.92 13.243,6.904 L13.243,17.019 L13.242,76.341 C13.242,79.325 15.662,81.745 18.646,81.745 L55.855,81.745 C58.84,81.745 61.258,79.325 61.258,76.341 L61.258,66.226 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path fill="#FFFFFF" d="M61.259,10.401 L13.243,10.401" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M61.259,10.401 L13.243,10.401"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path fill="#FFFFFF" d="M13.242,72.843 L61.258,72.843" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,72.843 L61.258,72.843"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#677BC5"
      d="M48.361,46.73 C43.821,44.286 39.28,48.775 34.739,51.381 C30.199,54.366 25.659,55.467 21.118,55.009 C21.119,50.664 21.119,45.407 21.118,39.234 C25.659,41.679 30.199,37.19 34.74,34.584 C39.28,31.599 43.821,30.498 48.361,30.956 L48.361,46.73 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M48.361,46.73 C43.821,44.286 39.28,48.775 34.739,51.381 C30.199,54.366 25.659,55.467 21.118,55.009 C21.119,50.664 21.119,45.407 21.118,39.234 C25.659,41.679 30.199,37.19 34.74,34.584 C39.28,31.599 43.821,30.498 48.361,30.956 L48.361,46.73 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M38.212,40.834 C38.211,38.375 36.656,37.441 34.74,38.515 C32.821,39.592 31.268,42.651 31.267,45.13 C31.269,47.587 32.825,48.525 34.74,47.449 C36.658,46.374 38.213,43.314 38.212,40.834"
    />
    <path
      fill="#677BC5"
      d="M53.673,53.148 C49.132,50.703 44.592,55.193 40.051,57.799 C35.511,60.784 30.971,61.885 26.43,61.427 L26.43,45.652 C30.971,48.097 35.511,43.607 40.052,41.002 C44.592,38.017 49.133,36.916 53.673,37.374 L53.673,53.148 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M53.673,53.148 C49.132,50.703 44.592,55.193 40.051,57.799 C35.511,60.784 30.971,61.885 26.43,61.427 L26.43,45.652 C30.971,48.097 35.511,43.607 40.052,41.002 C44.592,38.017 49.133,36.916 53.673,37.374 L53.673,53.148 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M43.524,47.252 C43.524,44.795 41.97,43.86 40.052,44.933 C38.137,46.008 36.581,49.069 36.58,51.548 C36.581,54.002 38.134,54.939 40.052,53.867 C41.971,52.79 43.525,49.731 43.524,47.252"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,47.731 C13.242,43.527 10.934,41.202 8.363,39.916 C5.21,38.338 1.5,40.656 1.5,44.181 L1.5,52.778 L1.5,78.641 C1.5,78.641 1.722,84.455 4.024,90.463"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M30.797,90.685 C30.797,68.164 13.538,66.225 13.538,66.225 L8.646,66.225 L8.646,92.294 L30.797,90.685 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M13.242,66.226 C13.242,66.226 30.343,68.147 30.343,90.46"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M72.151,40.777 C72.151,44.596 69.055,47.691 65.237,47.691 C61.418,47.691 58.322,44.596 58.322,40.777 C58.322,36.958 61.418,33.863 65.237,33.863 C69.055,33.863 72.151,36.958 72.151,40.777"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M72.151,40.777 C72.151,44.596 69.055,47.691 65.237,47.691 C61.418,47.691 58.322,44.596 58.322,40.777 C58.322,36.958 61.418,33.863 65.237,33.863 C69.055,33.863 72.151,36.958 72.151,40.777 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M70.188,54.627 C70.188,58.447 67.092,61.541 63.274,61.541 C59.455,61.541 56.359,58.447 56.359,54.627 C56.359,50.809 59.455,47.714 63.274,47.714 C67.092,47.714 70.188,50.809 70.188,54.627"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M70.188,54.627 C70.188,58.447 67.092,61.541 63.274,61.541 C59.455,61.541 56.359,58.447 56.359,54.627 C56.359,50.809 59.455,47.714 63.274,47.714 C67.092,47.714 70.188,50.809 70.188,54.627 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#FFFFFF"
      d="M68.225,68.478 C68.225,72.297 65.129,75.392 61.311,75.392 C57.492,75.392 54.396,72.297 54.396,68.478 C54.396,64.659 57.492,61.564 61.311,61.564 C65.129,61.564 68.225,64.659 68.225,68.478"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M68.225,68.478 C68.225,72.297 65.129,75.392 61.311,75.392 C57.492,75.392 54.396,72.297 54.396,68.478 C54.396,64.659 57.492,61.564 61.311,61.564 C65.129,61.564 68.225,64.659 68.225,68.478 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M56.763,90.462 C59.214,86.959 61.259,82.261 61.259,76.341"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M1.5,53.615 L4.012,53.615 C4.012,53.615 5.463,53.52 6.093,52.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="#677BC5"
      d="M36.467,16.745 L30.583,25.003 C30.112,25.664 30.556,26.612 31.336,26.612 L43.104,26.612 C43.884,26.612 44.328,25.664 43.857,25.003 L37.973,16.745 C37.595,16.215 36.845,16.215 36.467,16.745"
    />
  </svg>
);

export default PayOnline;



// WEBPACK FOOTER //
// ./src/assets/images/icons/pay-online.js